import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import useResolver from '../hooks/useResolver';
import RequestStore from '../store/RequestStore';
import PersonStore from '../store/PersonStore';
import TabbedRequests from '../components/TabbedRequests';

export interface ConnectedAllParticipationRequestsProps {}

const ConnectedMyRequests: React.FC<ConnectedAllParticipationRequestsProps> =
  () => {
    const requestStore = useResolver(RequestStore);
    const personStore = useResolver(PersonStore);

    useEffect(() => {
      requestStore.loadByCurrentPerson();
    }, []);

    return (
      <TabbedRequests
        requests={requestStore.currentPersonRequests}
        viewer={personStore.currentPerson}
      />
    );
  };

export default observer(ConnectedMyRequests);
